<div class="wizard-footer">
  @if (!hideRequiredHint()) {
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <span class="wizard-footer__mandatory">{{
          'rent_deposit.mandatory_field_hint_m' | translate
        }}</span>
      </div>
    </div>
  }

  <div class="row wizard-footer__actions">
    <div class="col-12 d-flex justify-content-end">
      @if (hasPrevious()) {
        <button im-button class="inverted" (click)="onPreviousStep()">
          {{ 'general.previous_a' | translate }}
        </button>
      }
      @if (hasNext()) {
        <button
          im-button
          class="primary ml8"
          [disabled]="disabled()"
          (click)="onNextStep()"
        >
          {{ 'general.next_a' | translate }}
        </button>
      }
      @if (hasFinish()) {
        <button
          im-button
          class="primary ml8"
          [disabled]="disabled()"
          (click)="onCompleteStep()"
        >
          {{ completeActionText() || 'general.complete_a' | translate }}
        </button>
      }
    </div>
  </div>
</div>
